import { ExternalLink } from 'lucide-react';
import { projectsData } from '../data/data';
import '../assets/css/projets.css';

const GithubIcon = ({ size = 20, ...props }) => (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" {...props}>
        <path d="M12 .5C5.73.5.98 5.24.98 11.52c0 5.02 3.26 9.28 7.78 10.78.57.1.78-.25.78-.55 0-.27-.01-1.16-.02-2.11-3.17.69-3.84-1.35-3.84-1.35-.52-1.32-1.27-1.67-1.27-1.67-1.04-.71.08-.7.08-.7 1.15.08 1.75 1.18 1.75 1.18 1.02 1.75 2.68 1.24 3.33.95.1-.74.4-1.24.72-1.53-2.53-.29-5.19-1.27-5.19-5.65 0-1.25.44-2.27 1.18-3.07-.12-.29-.51-1.46.11-3.04 0 0 .97-.31 3.18 1.18a11 11 0 0 1 5.79 0c2.2-1.49 3.17-1.18 3.17-1.18.63 1.58.24 2.75.12 3.04.74.8 1.18 1.82 1.18 3.07 0 4.39-2.67 5.36-5.21 5.64.41.36.77 1.06.77 2.14 0 1.55-.01 2.79-.01 3.17 0 .3.2.66.79.55A11.03 11.03 0 0 0 23.02 11.5C23.02 5.24 18.27.5 12 .5Z" />
    </svg>
);


function Project() {
    return (
        <>
          
            <section className="projects-container">
                <div className="projects-header">
                    <span className="eyebrow">Historique des déploiements</span>
                    <h1>Mes projets</h1>
                    <p>
                        Applications développées de bout en bout — de l'architecture
                        backend à l'interface, avec la même exigence que sur mes
                        environnements de production.
                    </p>
                </div>

                {projectsData?.length > 0 ? (
                    <div className="projects-grid">
                        {projectsData.map((project) => (
                            <article key={project.id} className="project-card">
                                <div className="project-image">
                                    <img src={project.image} alt={project.title} loading="lazy" />
                                    <div className="image-overlay">
                                        <a
                                            href={project.link}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="overlay-link"
                                            aria-label={`Voir ${project.title} en ligne`}
                                        >
                                            <ExternalLink size={26} />
                                        </a>
                                    </div>
                                </div>

                                <div className="project-content">
                                    <h3>{project.title}</h3>
                                    <p>{project.description}</p>

                                    <div className="project-tech">
                                        {project.technologies.map((tech) => (
                                            <span key={tech} className="tech-tag">{tech}</span>
                                        ))}
                                    </div>

                                    <div className="project-links">
                                        <a
                                            href={project.github}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="btn-secondary"
                                        >
                                            <GithubIcon size={16} /> Code source
                                        </a>
                                       
                                    </div>
                                </div>
                            </article>
                        ))}
                    </div>
                ) : (
                    <div className="empty-state">
                        <p>Aucun projet à afficher pour le moment.</p>
                    </div>
                )}
            </section>
        </>
    );
}

export default Project;
